// extracted by mini-css-extract-plugin
export default {"inputContainer":"DeclineEventModal_inputContainer__N9Opl","container":"DeclineEventModal_container__-ZqUf","buttons":"DeclineEventModal_buttons__fWqX6"};